(() => {
  const setupProductGallery = (productInfo) => {
    if (productInfo.dataset.rmGalleryReady === 'true') return;
    productInfo.dataset.rmGalleryReady = 'true';

    const updateProgress = () => {
      productInfo.querySelectorAll('.rm-product-slider-counter').forEach((counter) => {
        const current = Number(counter.querySelector('.slider-counter--current')?.textContent.trim() || 1);
        counter.querySelectorAll('.rm-product-slider-dot').forEach((segment, index) => {
          segment.classList.toggle('is-active', index + 1 === current);
        });
      });
    };

    let frame;
    const scheduleUpdate = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateProgress);
    };

    productInfo.querySelectorAll('.rm-product-slider-counter').forEach((counter) => {
      const observer = new MutationObserver(scheduleUpdate);
      observer.observe(counter, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });

    scheduleUpdate();
  };

  const initialize = () => {
    document.querySelectorAll('product-info').forEach(setupProductGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
